import { getInitialState, getPath } from "../../utils";

const initialState = {
  Filters: {},
  OrdersList: [],
  Order: {},
  NextPage: -1,
  PrevPage: -1,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case "SET_ORDERS_LIST_FILTERS":
      return setOrdersListFilters(state, action);
    case "SET_ORDERS_LIST":
      return setOrdersList(state, action);
    case "RESET_ORDERS_LIST_AND_FILTERS":
      return resetOrdersList(state, action);
    case "SET_ORDER_DETAILS":
      return setOrderDetails(state, action);
    case "RESET_ORDER_DETAILS":
      return resetOrderDetails(state, action);
    default:
      return state;
  }
}

const setOrdersListFilters = (state, action) => {
  return {
    ...state,
    Filters: action.payload || {},
  };
};

const setOrdersList = (state, action) => {
  const currentPage = action?.payload?.pagination?.current_page || 1;
    return {
    ...state,
    OrdersList: action?.payload?.orders || [],
    NextPage: action?.payload?.pagination?.has_next ? currentPage + 1 : -1,
    PrevPage: currentPage > 1 ? currentPage - 1 : -1,
    OrderCountByState: action?.payload?.order_count_by_state || {},
  };
};

const setOrderDetails = (state, action) => {
  return {
    ...state,
    Order: action.payload || {},
  };
};

const resetOrderDetails = (state, action) => {
  return {
    ...state,
    Order: initialState.Order,
  };
};

const resetOrdersList = (state, action) => {
  return {
    ...initialState,
  };
};
